(function($) {
    $(() => {        

		objectFitImages();

        document.querySelectorAll('.front-short-excerpt, .short-excerpt').forEach(el => {
            $clamp(el, {
				clamp: 3
			});
        });

        $('.member-list').slick({
            prevArrow: '<i class="fal fa-chevron-left prev-arrow"></i>',
            nextArrow: '<i class="fal fa-chevron-right next-arrow"></i>',
            adaptiveHeight: true
        });

        $('.month-switcher').slick({
            prevArrow: '<i class="fal fa-chevron-left prev-left-arrow"></i>',
            nextArrow: '<i class="fal fa-chevron-right next-right-arrow"></i>',
            asNavFor: '.month-events'
        });

        $('.month-events').slick({
            asNavFor: '.month-switcher',
            prevArrow: false,
            nextArrow: false,
            draggable: false,
            swipe: false,
            touchMove: false,
            adaptiveHeight: true
        });

        $('.back-button').click(ev => {
            window.history.back();
            ev.preventDefault();
		});
		
		// Fix pagination
		$('.pagination > .nav-links > .prev, .pagination > .nav-links > .next').remove();
    });
})(jQuery);
